import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
//IDOIA: edc-connector-client version 0.4.0
//import {PolicyDefinitionInput, PolicyInput} from "../../../mgmt-api-client/model";
import {PolicyDefinitionInput, PolicyInput, Policy, PolicyBuilder} from "../../../mgmt-api-client/model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-new-policy-dialog',
  templateUrl: './new-policy-dialog.component.html',
  styleUrls: ['./new-policy-dialog.component.scss']
})
export class NewPolicyDialogComponent implements OnInit {
  restrictionType: RestrictionType | 'json' = 'none';
  temporalStart: Date | null = null;
  temporalEnd: Date | null = null;
  locationValue: string = 'eu';
  purposeValue: string = 'commercial';

  prohibitionRestrictionType: RestrictionType | 'json' = 'none';
  prohibitionTemporalStart: Date | null = null;
  prohibitionTemporalEnd: Date | null = null;
  prohibitionLocationValue: string = 'eu';
  prohibitionPurposeValue: string = 'commercial';

  editMode: boolean = false;
  //IDOIA: edc-connector-client version 0.4.0
  //policy: PolicyInput = {
  policyInput: PolicyInput = {
    //IDOIA: edc-connector-client version 0.4.0
    //"@type": "set"
    "@type": "Set"
  };
  //IDOIA: edc-connector-client version 0.4.0
  policy: Policy = new PolicyBuilder()
          .raw(this.policyInput)
          .build();
  policyDefinition: PolicyDefinitionInput = {
    "policy": this.policy,
    "@id": ''
  };
  permissionsJson: string = '';
  prohibitionsJson: string = '';
  obligationsJson: string = '';
  additionalRestrictions: RestrictionItem[] = [];
  additionalProhibitions: RestrictionItem[] = [];

  @ViewChild('permissionsTextarea') permissionsTextarea?: ElementRef<HTMLTextAreaElement>;
  @ViewChild('prohibitionsTextarea') prohibitionsTextarea?: ElementRef<HTMLTextAreaElement>;
  @ViewChild('obligationsTextarea') obligationsTextarea?: ElementRef<HTMLTextAreaElement>;

  constructor(private dialogRef: MatDialogRef<NewPolicyDialogComponent>) {
  }

  ngOnInit(): void {
    this.editMode = true;

    const today = new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);

    this.temporalStart = today;
    this.temporalEnd = nextYear;
    this.prohibitionTemporalStart = today;
    this.prohibitionTemporalEnd = nextYear;

    if (this.restrictionType !== 'json') {
      this.syncPermissionsFromRestrictions();
    }

    if (this.prohibitionRestrictionType !== 'json') {
      this.syncProhibitionsFromRestrictions();
    }
  }

  ngAfterViewInit(): void {
    this.syncAllTextareaHeights();
  }

  onRestrictionTypeChange(): void {
    if (this.restrictionType === 'json') {
      this.syncAllTextareaHeights();
      return;
    }

    if (this.restrictionType === 'temporal') {
      this.onTemporalRangeChange();
      return;
    }

    if (this.restrictionType === 'location') {
      this.onLocationChange();
      return;
    }

    if (this.restrictionType === 'purpose') {
      this.onPurposeChange();
      return;
    }

    this.syncPermissionsFromRestrictions();
  }

  onTemporalRangeChange(): void {
    this.syncPermissionsFromRestrictions();
  }

  onLocationChange(): void {
    this.syncPermissionsFromRestrictions();
  }

  onPurposeChange(): void {
    this.syncPermissionsFromRestrictions();
  }

  addRestriction(): void {
    if (this.restrictionType === 'json') {
      return;
    }

    this.additionalRestrictions.push(this.createRestrictionItem('none'));
    this.syncPermissionsFromRestrictions();
  }

  removeRestriction(index: number): void {
    this.additionalRestrictions.splice(index, 1);
    this.syncPermissionsFromRestrictions();
  }

  onAdditionalRestrictionTypeChange(index: number): void {
    const current = this.additionalRestrictions[index];
    this.additionalRestrictions[index] = this.createRestrictionItem(current.type);
    this.syncPermissionsFromRestrictions();
  }

  onAdditionalRestrictionChange(): void {
    this.syncPermissionsFromRestrictions();
  }

  onProhibitionRestrictionTypeChange(): void {
    if (this.prohibitionRestrictionType === 'json') {
      this.syncAllTextareaHeights();
      return;
    }

    if (this.prohibitionRestrictionType === 'temporal') {
      this.onProhibitionTemporalRangeChange();
      return;
    }

    if (this.prohibitionRestrictionType === 'location') {
      this.onProhibitionLocationChange();
      return;
    }

    if (this.prohibitionRestrictionType === 'purpose') {
      this.onProhibitionPurposeChange();
      return;
    }

    this.syncProhibitionsFromRestrictions();
  }

  onProhibitionTemporalRangeChange(): void {
    this.syncProhibitionsFromRestrictions();
  }

  onProhibitionLocationChange(): void {
    this.syncProhibitionsFromRestrictions();
  }

  onProhibitionPurposeChange(): void {
    this.syncProhibitionsFromRestrictions();
  }

  addProhibitionRestriction(): void {
    if (this.prohibitionRestrictionType === 'json') {
      return;
    }

    this.additionalProhibitions.push(this.createRestrictionItem('none'));
    this.syncProhibitionsFromRestrictions();
  }

  removeProhibitionRestriction(index: number): void {
    this.additionalProhibitions.splice(index, 1);
    this.syncProhibitionsFromRestrictions();
  }

  onAdditionalProhibitionTypeChange(index: number): void {
    const current = this.additionalProhibitions[index];
    this.additionalProhibitions[index] = this.createRestrictionItem(current.type);
    this.syncProhibitionsFromRestrictions();
  }

  onAdditionalProhibitionChange(): void {
    this.syncProhibitionsFromRestrictions();
  }

  autoResize(textarea: HTMLTextAreaElement): void {
    if (!textarea) {
      return;
    }

    textarea.style.height = 'auto';
    const targetHeight = Math.min(textarea.scrollHeight, 250);
    textarea.style.height = `${targetHeight}px`;
    textarea.style.overflowY = textarea.scrollHeight > 250 ? 'auto' : 'hidden';
  }

  private syncAllTextareaHeights(): void {
    setTimeout(() => {
      this.autoResize(this.permissionsTextarea?.nativeElement as HTMLTextAreaElement);
      this.autoResize(this.prohibitionsTextarea?.nativeElement as HTMLTextAreaElement);
      this.autoResize(this.obligationsTextarea?.nativeElement as HTMLTextAreaElement);
    });
  }

  private createRestrictionItem(type: RestrictionType): RestrictionItem {
    const today = new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);

    return {
      type,
      temporalStart: type === 'temporal' ? today : null,
      temporalEnd: type === 'temporal' ? nextYear : null,
      locationValue: 'eu',
      purposeValue: 'commercial'
    };
  }

  private syncPermissionsFromRestrictions(): void {
    if (this.restrictionType === 'json') {
      this.syncAllTextareaHeights();
      return;
    }

    const permissions: any[] = [];

    const primaryPermission = this.buildPermissionFromRestriction(
      this.restrictionType,
      this.temporalStart,
      this.temporalEnd,
      this.locationValue,
      this.purposeValue
    );

    if (primaryPermission) {
      permissions.push(primaryPermission);
    }

    this.additionalRestrictions.forEach((item) => {
      const additionalPermission = this.buildPermissionFromRestriction(
        item.type,
        item.temporalStart,
        item.temporalEnd,
        item.locationValue,
        item.purposeValue
      );

      if (additionalPermission) {
        permissions.push(additionalPermission);
      }
    });

    if (!permissions.length) {
      this.permissionsJson = '';
      this.syncAllTextareaHeights();
      return;
    }

    if (permissions.length === 1) {
      this.permissionsJson = JSON.stringify(permissions[0], null, 2);
    } else {
      this.permissionsJson = permissions
        .map(permission => JSON.stringify(permission, null, 2))
        .join(',\n');
    }
    this.syncAllTextareaHeights();
  }

  private syncProhibitionsFromRestrictions(): void {
    if (this.prohibitionRestrictionType === 'json') {
      this.syncAllTextareaHeights();
      return;
    }

    const prohibitions: any[] = [];

    const primaryProhibition = this.buildPermissionFromRestriction(
      this.prohibitionRestrictionType,
      this.prohibitionTemporalStart,
      this.prohibitionTemporalEnd,
      this.prohibitionLocationValue,
      this.prohibitionPurposeValue
    );

    if (primaryProhibition) {
      prohibitions.push(primaryProhibition);
    }

    this.additionalProhibitions.forEach((item) => {
      const additionalProhibition = this.buildPermissionFromRestriction(
        item.type,
        item.temporalStart,
        item.temporalEnd,
        item.locationValue,
        item.purposeValue
      );

      if (additionalProhibition) {
        prohibitions.push(additionalProhibition);
      }
    });

    if (!prohibitions.length) {
      this.prohibitionsJson = '';
      this.syncAllTextareaHeights();
      return;
    }

    if (prohibitions.length === 1) {
      this.prohibitionsJson = JSON.stringify(prohibitions[0], null, 2);
    } else {
      this.prohibitionsJson = prohibitions
        .map(prohibition => JSON.stringify(prohibition, null, 2))
        .join(',\n');
    }
    this.syncAllTextareaHeights();
  }

  private buildPermissionFromRestriction(
    type: RestrictionType,
    temporalStart: Date | null,
    temporalEnd: Date | null,
    locationValue: string,
    purposeValue: string
  ): any | null {
    if (type === 'none') {
      return null;
    }

    if (type === 'temporal') {
      const temporalConstraints = this.buildTemporalConstraints(temporalStart, temporalEnd);
      if (!temporalConstraints.length) {
        return null;
      }

      return {
        action: 'use',
        constraint: temporalConstraints
      };
    }

    if (type === 'location') {
      const locationConstraint = this.buildLocationConstraint(locationValue);
      if (!locationConstraint) {
        return null;
      }

      return {
        action: 'use',
        constraint: locationConstraint
      };
    }

    if (type === 'purpose') {
      const purposeConstraint = this.buildPurposeConstraint(purposeValue);
      if (!purposeConstraint) {
        return null;
      }

      return {
        action: 'use',
        constraint: purposeConstraint
      };
    }

    return null;
  }

  private buildTemporalConstraints(start: Date | null, end: Date | null): any[] {
    if (!start || !end) {
      return [];
    }

    const startDate = new Date(start);
    const endDate = new Date(end);

    if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
      return [];
    }

    return [
      {
        '@type': 'AtomicConstraint',
        leftOperand: 'https://w3id.org/edc/v0.0.1/ns/timeInterval',
        rightOperand: {
          '@type': 'xsd:date',
          '@value': startDate.toISOString()
        },
        operator: {
          '@id': 'odrl:gteq'
        }
      },
      {
        '@type': 'AtomicConstraint',
        leftOperand: 'https://w3id.org/edc/v0.0.1/ns/timeInterval',
        rightOperand: {
          '@type': 'xsd:date',
          '@value': endDate.toISOString()
        },
        operator: {
          '@id': 'odrl:lteq'
        }
      }
    ];
  }

  private buildLocationConstraint(locationValue: string): any | null {
    if (!locationValue || locationValue.trim() === '') {
      return null;
    }

    return {
      '@type': 'AtomicConstraint',
      'odrl:leftOperand': 'https://w3id.org/edc/v0.0.1/ns/location',
      rightOperand: {
        '@type': 'xsd:string',
        '@value': locationValue.trim()
      },
      operator: {
        '@id': 'odrl:eq'
      }
    };
  }

  private buildPurposeConstraint(purposeValue: string): any | null {
    if (!purposeValue || purposeValue.trim() === '') {
      return null;
    }

    return {
      '@type': 'AtomicConstraint',
      'odrl:leftOperand': 'https://w3id.org/edc/v0.0.1/ns/purpose',
      rightOperand: {
        '@type': 'xsd:string',
        '@value': purposeValue.trim()
      },
      operator: {
        '@id': 'odrl:eq'
      }
    };
  }

  onSave() {
    if (this.permissionsJson && this.permissionsJson !== '') {
      this.policy.permission = this.parsePolicyEntriesJson(this.permissionsJson);
    }

    if (this.prohibitionsJson && this.prohibitionsJson !== '') {
      this.policy.prohibition = this.parsePolicyEntriesJson(this.prohibitionsJson);
    }

    if (this.obligationsJson && this.obligationsJson !== '') {
      this.policy.obligation = JSON.parse(this.obligationsJson);
    }

    this.policy["@context"]="http://www.w3.org/ns/odrl.jsonld"


    this.dialogRef.close({

      policy : this.policyDefinition.policy,
      '@id': this.policyDefinition.id
    })
  }

  private parsePolicyEntriesJson(rawEntries: string): any {
    const trimmedEntries = rawEntries.trim();

    try {
      return JSON.parse(trimmedEntries);
    } catch {
      return JSON.parse(`[${trimmedEntries}]`);
    }
  }
}

type RestrictionType = 'none' | 'temporal' | 'location' | 'purpose';

interface RestrictionItem {
  type: RestrictionType;
  temporalStart: Date | null;
  temporalEnd: Date | null;
  locationValue: string;
  purposeValue: string;
}
